<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar
    class="block w-full"
    name="Leeslijst | Stopwatch"
    [steps]="matrices().length"
    [progress]="_state.type === 'INSTRUCTION' ? 0 : _state.type === 'READING' ? index() : matrices().length"
  />

  <rid-mechanic-content>
    @if (_state.type !== 'INSTRUCTION') {
      <!-- title -->
      @if (_state.type === 'READING') {
        <rid-mechanic-title animate.enter="wait-500" [title]="'Lees de woorden nauwkeurig en snel hardop'" />
      }

      <!-- matrices -->
      <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
        @for (matrix of matrices(); track $index) {
          <rid-word-matrix [matrix]="matrix" />
        }
      </rid-horizontal-pages>

      <!-- buttons -->
      @if (_state.type === 'READING' && index() === matrices().length - 1) {
        <rid-bottom-button content="Klaar!" (clicked)="finishReading()" />
      }
      @if (_state.type === 'VIEWING') {
        <div class="absolute bottom-8 flex justify-center gap-4">
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Nog een keer"
            variant="SECONDARY"
            [disabled]="true"
          />
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Volgende"
            (click)="finish()"
          />
        </div>
      }

      <!-- review toast -->
      @if (_state.type === 'FEEDBACK') {
        <rid-feedback-comparison-toast
          [config]="durationComparison"
          [value]="_state.duration"
          [previousValue]="previousDuration()"
          (click)="state.set({ type: 'RATING' })"
          (continued)="state.set({ type: 'RATING' })"
        />
      }

      <!-- accuracy toast -->
      @if (_state.type === 'ACCURACY_FEEDBACK') {
        <rid-feedback-comparison-toast
          [config]="accuracyComparison"
          [value]="_state.accuracy"
          [previousValue]="previousAccuracy()"
          (click)="finish()"
          (continued)="finish()"
        />
      }

      <!-- overlay -->
      @if (_state.type === 'RATING') {
        <rid-modal-background />
        <rid-rating-modal (canceled)="state.set({ type: 'VIEWING' })" (continued)="rate($event)" />
      }
    }

    @if (_state.type === 'INSTRUCTION') {
      <rid-modal-background [blur]="true" />
      <rid-instruction-modal (started)="start()">
        Lees alle woorden hardop.<br />Doe dit zo nauwkeurig en snel mogelijk. Druk dan op 'Klaar!'.
      </rid-instruction-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
